module.exports = __webpack_public_path__ + "static/media/rfg.2bacec55.png";